export const SAFER_RISK_LABELS = {
    OUT_OF_SERVICE: "Carrier is marked OUT OF SERVICE by FMCSA",
    NOT_AUTHORIZED: "Carrier is NOT AUTHORIZED by FMCSA",
    AUTHORITY_REVOKED: "Carrier authority has been revoked",
};

export function saferRiskSummary(snapshot) {
    if (!snapshot) return null;
    if (snapshot.error === "unavailable") return { kind: "unavailable" };
    if (!snapshot.has_risk_flag) return null;
    const reasons = snapshot.risk_reasons || [];
    return {
        kind: "risk",
        reasons,
        messages: reasons.map((r) => SAFER_RISK_LABELS[r] || r),
    };
}

export function fmtFetchedAt(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    } catch {
        return iso;
    }
}
